export default __webpack_public_path__ + "static/media/KirinyagaAmis.62b5b8f0.apk";